export const HERO_CONSTANTS = {
  button: {
    label: "Run your Proof-of-Concept projects now",
    link: "#contact-us",
  },
  title: "Validate & Test Before Full Deployment",
};
